module.exports = __webpack_public_path__ + "static/media/2.eb56c267.jpg";